import React from 'react';
import Table from "./Table";
import "../App.css";

const IFrame = (props) => {
    const { isin, language, T } = props;
    return (
        <div className="iframe">
            <Table isin={isin} language={language} T={T} />
        </div>
    );
}

export default IFrame;